import { Component } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TimeEntryCategory, TimeEntryCategoryInput } from '../../entities/timeEntryCategory/timeEntryCategory';
import { LoadingService } from '../../services/loading.service';
import { TimeTrackingCategoryService } from '../../services/timeTrackingCategories/timeTrackingCategories.service';
import { EditDialogComponent } from '../editDialog/editDialogComponent';
import { EditDialogInstance } from '../editDialog/editDialogService';

@Component({
  selector: 'app-time-entry-category-dialog',
  templateUrl: './time-entry-category-dialog.component.html',
  styleUrls: ['./time-entry-category-dialog.component.scss']
})
export class TimeEntryCategoryDialogDialogComponent
  implements EditDialogInstance {

    timeEntryCategoryForm: FormGroup;
    timeEntryCategory: TimeEntryCategory;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public timeTrackingCategoryService: TimeTrackingCategoryService,
    public loadingService: LoadingService,
  ) {

    if (this.config.data) {
      this.timeEntryCategory = this.config.data;
    }

    this.timeEntryCategoryForm = new FormGroup({});
    this.timeEntryCategoryForm.addControl('id', new FormControl());
    // add form controls
    this.timeEntryCategoryForm.addControl('name', new FormControl(undefined, Validators.required));
    this.timeEntryCategoryForm.addControl('externalId', new FormControl());
    this.timeEntryCategoryForm.addControl('color', new FormControl('#2196f3', [Validators.required, this.hexColorValidator()]));
    this.timeEntryCategoryForm.addControl('enabled', new FormControl());

    if (this.timeEntryCategory) {
      this.timeEntryCategoryForm.patchValue(this.timeEntryCategory);
    }

    this.timeEntryCategoryForm.valueChanges.subscribe((value) => {
      console.log(value);
    });
  }


  onConfirm(editDialogComponent: EditDialogComponent<any>): void {
    this.loadingService.setLoading(true);
    let timeEntryCategoryInput = new TimeEntryCategoryInput(this.timeEntryCategoryForm.value);
    if(this.timeEntryCategory){
      this.timeTrackingCategoryService.updateTimeEntryCategory(timeEntryCategoryInput, (result: any) => {
        this.loadingService.setLoading(false);
        this.ref.close(result?.data?.updateTimeEntryCategory?.id);
      });
    } else {
      this.timeTrackingCategoryService.createTimeEntryCategory(timeEntryCategoryInput, (result: any) => {
        this.loadingService.setLoading(false);
        this.ref.close(result?.data?.createTimeEntryCategory?.id);
      });
    }
  }

  onReject(editDialogComponent: EditDialogComponent<any>): void {
    this.ref.close(false);
  }

  getEditForm(): FormGroup {
    return this.timeEntryCategoryForm;
  }

  hexColorValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const value = control.value;
      const valid = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(value);
      return valid ? null : { invalidHexColor: true };
    };
  }

}
